import { MenuItemProps, useTranslations } from "@bsm/component";

export const useInlineMIssingItemMenu = (): MenuItemProps[] => {
    const [
        EDIT,
        DELETE,
    ] = useTranslations(i18n)

    return [
        {
            ke: "delete",
            label: DELETE,
            startIcon: 'fa-solid fa-trash',
        },
    ];
}

const i18n = [
   "std_edit",
   "std_delete",
]


